module.exports = __webpack_public_path__ + "img/beauty-siluet.6269609d.jpg";